// const DEV_SERVER = 'https://10.20.30.88:18442';  dgrv4  test用

const DEV_SERVER_HOST = 'https://localhost'; //esg 
// const DEV_SERVER_HOST = 'https://10.20.30.99'; //esg 
// const DEV_SERVER_PORT = '18442'; //port
const DEV_SERVER_PORT = '18080'; 
const DEV_LOCALE_PATH = "/website/esg/ui/locales"; //port 3000 BrowserRouter 前綴加上 website/esg/ui
const PRO_LOCALE_PATH = "/website/esg/ui/locales";
const DEV_IMAGE_PATH = `${DEV_SERVER_HOST}:${DEV_SERVER_PORT}/website/esg/ui/images`; //port 3000 BrowserRouter 前綴加上 website/esg/ui
const PRO_IMAGE_PATH = "/website/esg/ui/images";

export const environment = {
    host: process.env.NODE_ENV === 'development' ? `${DEV_SERVER_HOST}` : `${window.location.protocol}//${window.location.hostname}`,
    port: process.env.NODE_ENV === 'development' ? `${DEV_SERVER_PORT}` : `${window.location.port}`,
    apiUrl:  process.env.NODE_ENV === 'development' ? `${DEV_SERVER_HOST}:${DEV_SERVER_PORT}` : `${window.location.protocol}//${window.location.hostname}${window.location.port===''?'':`:${window.location.port}`}`,
    localePath: process.env.NODE_ENV === 'development' ? DEV_LOCALE_PATH : PRO_LOCALE_PATH,
    imagePath:process.env.NODE_ENV === 'development' ? DEV_IMAGE_PATH : PRO_IMAGE_PATH,
    contextPath: 'website',
    contextVersion: 'esg',
    front:'ui',
    basicModule: 'api', //處理大部分api服務
    dgrPath: 'dgrv4', 
    dgrModule_11: '11',
    apiContextPath: 'website/esg'
};



